import {
  EcommerceEventGa4,
  NavigationEventGa4,
  pushEvent as commonPushEvent,
} from "@storebrand-digital/common-google-analytics";
import { isFirstStep, isLastStep } from "Store/steps/stepsUtils";
import { AppPartName, ComponentPrefix } from "./analyticsTypes";

import { StepStatusState } from "Store/steps/stepsInterfaces";
import { formatTrackId } from "./analyticsMappings";

export const buttonNextTrackId = (text: string): string =>
  `${ComponentPrefix.BUTTON_NEXT}-${formatTrackId(text)}`;
export const buttonPreviousTrackId = (text: string): string =>
  `${ComponentPrefix.BUTTON_PREVIOUS}-${formatTrackId(text)}`;
export const buttonConsentTrackId = (text: string): string =>
  `${ComponentPrefix.BUTTON_CONSENT}-${formatTrackId(text)}`;
export const buttonDetailsTrackId = (text: string): string =>
  `${ComponentPrefix.BUTTON_DETAILS}-${formatTrackId(text)}`;
export const buttonTrackId = (text: string): string =>
  `${ComponentPrefix.BUTTON}-${formatTrackId(text)}`;
export const linkTrackId = (text: string): string =>
  `${ComponentPrefix.LINK}-${formatTrackId(text)}`;
export const radioTrackId = (id: string): string =>
  `${ComponentPrefix.RADIO}-${formatTrackId(id)}`;
export const inputTrackId = (id: string): string =>
  `${ComponentPrefix.INPUT}-${formatTrackId(id)}`;
export const checkboxTrackId = (id: string, value: boolean): string =>
  `${ComponentPrefix.CHECKBOX}-${formatTrackId(id)}-${String(value)}`;

export const oneEventPerProductInCart = (
  page?: AppPartName | string,
): boolean =>
  page === AppPartName.OFFER ||
  page === AppPartName.OFFER_ACCEPT ||
  page === AppPartName.CONFIRM ||
  page === AppPartName.RECEIPT;

export function isFirstCheckoutStep(stepStatus: StepStatusState): boolean {
  const matches = window.location.href.match(/\/utsjekk\/C-.*/);
  return !!(
    matches &&
    matches.length > 0 &&
    isFirstStep(stepStatus.steps, stepStatus.activeStepId)
  );
}

/**
 * Is it the last step of the checkout part of the app?
 */
export function isConfirmCheckoutStep(stepStatus: StepStatusState): boolean {
  const matches = window.location.href.match(/\/utsjekk\/C-.*/);
  return !!(
    matches &&
    matches.length > 0 &&
    isLastStep(stepStatus.steps, stepStatus.activeStepId)
  );
}

/**
 * Push e-commerce event to Google Analytics.
 */
export const pushEcommerceEvent = (event: EcommerceEventGa4): void => {
  commonPushEvent(event);
};

/**
 * Push navigation event to Google Analytics.
 */
export const pushNavigationEvents = (events?: NavigationEventGa4[]): void => {
  events?.forEach((event) => {
    commonPushEvent(event);
  });
};
